import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Table, Pagination } from 'semantic-ui-react';
import { listTransactionTables } from '../graphql/queries';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();
const PAGE_SIZE = 50;

function Transactions() {
  // set state
  const navigate = useNavigate();
  const [customerName, setCustomerName] = useState("");
  const [transactionInfo, setTransactionInfo] = useState([]);
  const [activePage, setActivePage] = useState(1);
  // first data grab
  useEffect(() => {
    async function fetchData() {


  let allItems = [];
  let nextToken = null;

  do {
    const result = await client.graphql({
      query: listTransactionTables,
      variables: {
        limit: 1000,        // max per request (use highest allowed)
        nextToken: nextToken
      }
    });

    const data = result.data.listTransactionTables;

    allItems = [...allItems, ...data.items];
    nextToken = data.nextToken;

  } while (nextToken);

      
      if (allItems) {
        allItems.sort(dynamicSort("-InsertTime"));
        setTransactionInfo(allItems);
      }
    }

    fetchData();
  }, []);

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  const openTransaction = (id) => {
    if (id) {
      navigate('/transaction/' + id, { replace: true });
    }
  }
  const getClassName = (error) => {
    if (error === "Record updated") {
      return "positive";
    }
    return "negative";
  }
  const filterTransactions = () => {
    if(customerName === '' || customerName === undefined) {
      return transactionInfo;
    }
    return transactionInfo.filter(t => t.CustomerName !== null && t.CustomerName.toLowerCase().includes(customerName.toLowerCase()));
  }

  const filteredTransactions = filterTransactions();
  const totalPages = Math.max(1, Math.ceil(filteredTransactions.length / PAGE_SIZE));
  const pagedTransactions = filteredTransactions.slice((activePage - 1) * PAGE_SIZE, activePage * PAGE_SIZE);

  const onCustomerNameChange = (e) => {
    setCustomerName(e.target.value);
    setActivePage(1);
  }

  return (
    <>
    <div className="field">
      <h1 htmlFor="CustomerName">Customer Name Filter</h1>
      <input type="text"  placeholder="Customer Name" id="CustomerName" value={customerName} onChange={onCustomerNameChange} />
    </div>
    <br></br>
    <Table singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Customer Name</Table.HeaderCell>
          <Table.HeaderCell>Device</Table.HeaderCell>
          <Table.HeaderCell>Barcode</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
          <Table.HeaderCell>Insert Time</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>

        {pagedTransactions.map(tData => {
          return (
            <Table.Row key={tData.id} onClick={() => openTransaction(tData.id)} className={getClassName(tData.Error)}>
              <Table.Cell>{tData.CustomerName}</Table.Cell>
              <Table.Cell>{tData.SerialNumber}</Table.Cell>
              <Table.Cell>{tData.Barcode}</Table.Cell>
              <Table.Cell>{tData.Error}</Table.Cell>
              <Table.Cell>{tData.InsertTime}</Table.Cell>
            </Table.Row>);
        })}

      </Table.Body>
    </Table>
    <Pagination
      activePage={activePage}
      totalPages={totalPages}
      onPageChange={(e, { activePage }) => setActivePage(activePage)}
    />
    </>
  );
}

export default Transactions